import * as React from "react"
import { Zoom } from "@common/components/zoom"
import { SvgXml } from "react-native-svg"

export const PinchableSvgBox = React.forwardRef(
    function PinchableSvgBox({ imageStyle, svgContent, onLayout }, ref) {
        return (
            <Zoom
                ref={ref}
                style={{
                    flex: 1,
                }}
            >
                <SvgXml
                    xml={svgContent}
                    width="100%"
                    height="100%"
                    style={{
                        ...imageStyle,
                    }}
                    onLayout={onLayout}
                />
            </Zoom>
        )
    }
)
